import { render, staticRenderFns } from "./GExamDetailProgressClassTable.vue?vue&type=template&id=e2439e7e&"
import script from "./GExamDetailProgressClassTable.vue?vue&type=script&lang=ts&"
export * from "./GExamDetailProgressClassTable.vue?vue&type=script&lang=ts&"
import style0 from "./GExamDetailProgressClassTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports